// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import exact from './exact';
import { withRouteContext } from './RouterContext';
import type { Route } from './types';

type Props = {|
  props: {
    children: React.Node,
    [string]: any,
  },
  route: Route,
  previousRoute: any,
  popping: boolean,
  navigate: any,
|};

const Exact = ({ route, props: { children, ...predicates } }: Props) => {
  if (!exact(route, predicates)) {
    return null;
  }
  if (children) {
    return children;
  }
  return null;
};

/** Default export of <Exact/> component wrapped with route context */
export default withRouteContext(Exact);
